<app-st-banner [idVal]="'banner-id'" [breadCrumbs]="this.breadCrumbs"
               [hasElementTags]="false" [elementTags]="[]" [requiresSignOutButton]="this.requiresSignOutButton"
></app-st-banner>
<br><br><br><br><br><br>
<div class="container-xxl">
  <!-- Google tag (gtag.js) -->

  <script async src="https://www.googletagmanager.com/gtag/js?id=G-LWQRV5QS22"></script>
  <script> window.dataLayer = window.dataLayer || [];  function gtag(){dataLayer.push(arguments);} gtag('js', new Date()); gtag('config', 'G-LWQRV5QS22'); </script>

  <div class="row pt-4 pb5">
    <div class="col-2 d-flex justify-content-center neg-margin">
    </div>
    <div class="col-8">
      <app-st-header-title [inputVal]="profileName"></app-st-header-title>
    </div>
  </div>
  <div *ngIf="showMessages" class="container st-form text-danger" #goUp>
    <app-st-span><b>Please validate the following: </b></app-st-span>
    <div *ngFor="let errorMsg of messages" class="alert alert-danger" role="alert">
      <b>{{errorMsg.field}}:</b> {{errorMsg.detail}}
    </div>
    <br>
  </div>
  <div class="container st-form">
    <div class="col2 d-grid gap-2 d-md-flex justify-content-md-end align-items-end">
      <app-st-button-cancel [idVal]="'top-cancel-button-id'" [label]="'Cancel'" [primary]="false"
                            (click)="this.onCancel()"></app-st-button-cancel>
      <app-st-button [idVal]="'top-save-button-id'" [label]="'Submit'" [primary]="true"
                     (click)="this.onSave()"></app-st-button>
    </div>
    <app-st-header-title [inputVal]="'User Information'"></app-st-header-title>
    <div class="row pt-2">
      <div class="col">
        <app-st-input-text [idVal]="'first-name-text-id'"
                           [label]="'*First Name'" [inputVal]="savedFirstName"
                           [placeHolderVal]="'First Name'"
                           [requiredVal]="true"
                           [maxLength]="40"
        ></app-st-input-text>
      </div>
      <div class="col">
        <app-st-input-text [idVal]="'last-name-text-id'"
                           [label]="'*Last Name'" [inputVal]="savedLastName"
                           [placeHolderVal]="'Last Name'"
                           [requiredVal]="true"
                           [maxLength]="40"
        ></app-st-input-text>
      </div>
    </div>
    <div class="row pt-2">
      <div class="col">
        <app-st-input-text-phone [idVal]="'phone-number-text-id'"
                           [label]="'*Phone Number: (Format: 1234567890)'" [inputVal]="savedPhoneNumber" [requiredVal]="true" [maxLength]="20"
        ></app-st-input-text-phone>
      </div>
    </div>
    <div class="row pt-2">
      <div class="col">
        <app-st-input-text-email *ngIf="createFlag" [idVal]="'email-text-id'"
                                 [label]="'*Email'" [inputVal]="savedEmail" [requiredVal]="true" [disabled]="false"
                                 [maxLength]="40"
        >
        </app-st-input-text-email>
        <app-st-input-text-email *ngIf="!createFlag" [idVal]="'email-text-id'"
                                 [label]="'*Email'" [inputVal]="savedEmail" [requiredVal]="true" [disabled]="true"
                                 [maxLength]="40"
        >
        </app-st-input-text-email>
      </div>
      <div class="col">
        <app-st-input-text-email *ngIf="createFlag" [idVal]="'confirm-email-text-id'"
                                 [inputVal]="this.savedConfirmedEmail"
                                 [label]="'*Confirm Email'"  [requiredVal]="true" [disabled]="false"
                                 [maxLength]="40"
        >
        </app-st-input-text-email>
      </div>
    </div>

    <!--
    <div class="row pt-2">
      <div class="col">
        <app-st-input-text [idVal]="'address-line-1-text-id'"
                           [label]="'*Address Line 1'" [inputVal]="savedAddressLine1"
                           [disabled]="false"
                           [maxLength]="100"
        ></app-st-input-text>
      </div>
    </div>
    <div class="row pt-2">
      <div class="col">
        <app-st-input-text [idVal]="'address-line-2-text-id'"
                           [label]="'Address Line 2'" [inputVal]="savedAddressLine2"
                           [disabled]="false"
                           [maxLength]="100"
        ></app-st-input-text>
      </div>
    </div>
    <div class="row pt-2">
      <div class="col">
        <app-st-input-text [idVal]="'city-text-id'"
                           [label]="'*City'" [inputVal]="savedCity"
                           [disabled]="false"
                           [maxLength]="100"
        ></app-st-input-text>
      </div>
    </div>

    <app-st-span [inputVal]="'*State:'"></app-st-span><br>
    <app-st-select [idVal]="'usa-dropdown-list-id'" [defaultOption]="'Select State'" [label]="''" [idKey]="'usaStateId'" [displayKey]="'usaState'" [valueKey]="'usaState'" [inputArray]="this.statesList"></app-st-select>

    <div class="row pt-2">
      <div class="col">
        <app-st-input-text [idVal]="'country-text-id'"
                           [label]="'*Country'" [inputVal]="savedCountry"
                           [disabled]="false"
                           [maxLength]="50"
        ></app-st-input-text>
      </div>
    </div>
    <div class="row pt-2">
      <div class="col">
        <app-st-input-text [idVal]="'zip-code-text-id'"
                           [label]="'*Zip Code: (Formats: 12345, 123456789, or 12345-6789)'" [inputVal]="savedZipCode"
                           [disabled]="false"
                           [maxLength]="20"
        ></app-st-input-text>
      </div>
    </div>-->

    <div class="row pt-2" *ngIf="createFlag && this.isANonprofit">
      <div class="col">
        <app-st-input-text [idVal]="'ein-text-id'"
                           [label]="'*EIN: (Must be 9 digits in these formats: 123456789 or 12-3456789)'" [inputVal]="savedEIN"
                           [requiredVal]="true"
                           [maxLength]="20"
        ></app-st-input-text>
      </div>
    </div>
    <div class="row pt-2" *ngIf="createFlag && !this.isANonprofit">
      <div class="col">
        <app-st-input-text [idVal]="'company-name-text-id'"
                           [label]="'*Organization Name'" [inputVal]="savedCompanyName"
                           [requiredVal]="true"
        ></app-st-input-text>
      </div>
    </div>
    <br>
    <div *ngIf="createFlag" class="col2 d-grid gap-2 d-md-flex justify-content-md-start align-items-start">
      <app-st-button *ngIf="createFlag && !this.isANonprofit" [idVal]="'is-a-nonprofit-button-id'" [label]="'I am a nonprofit.'" [primary]="true"
                            (click)="this.toggleIsANonprofitButton()"></app-st-button>
      <app-st-button *ngIf="createFlag && this.isANonprofit"  [idVal]="'is-not-a-nonprofit-button-id'" [label]="'I am NOT a nonprofit.'" [primary]="true"
                     (click)="this.toggleIsANonprofitButton()"></app-st-button>
    </div>
    <br>
    <div class="row pt-2" *ngIf="createFlag">
      <div class="col">
        <app-st-span [inputVal]="'*Cause Category: '" class="webtext-black-bold"></app-st-span><br>
        <app-st-select [idVal]="'cause-category-dropdown-list-id'" [defaultOption]="'Cause Category'" [label]="''" [idKey]="'causeId'" [displayKey]="'causeDisplayName'" [valueKey]="'causeName'" [inputArray]="this.causeDropdownList"
          [inputVal]="this.savedCause"
        ></app-st-select>
      </div>
    </div>
    <br>
    <div class="row pt-2" *ngIf="!createFlag">
      <div class="col">
        <app-st-input-text [idVal]="'ein-text-id'"
                           [label]="'*EIN'" [inputVal]="savedEIN"
                           [disabled]="false"
                           [maxLength]="20"
        ></app-st-input-text>
      </div>
    </div>
    <div class="row pt-2" *ngIf="!createFlag">
      <div class="col">
        <app-st-input-text [idVal]="'company-name-text-id'"
                           [label]="'*Organization Name'" [inputVal]="savedCompanyName"
                           [disabled]="false"
                           [maxLength]="200"
        ></app-st-input-text>
      </div>
    </div>
    <br>
    <div *ngIf="createFlag">
      <br>
      <p class="webtext-black"><b>Password Policy:</b></p>
      <ul class="webtext-black">
        <li>Password must be at least 10 characters.</li>
        <li>Password must contain at least one lowercase letter.</li>
        <li>Password must contain at least one uppercase letter.</li>
        <li>Password must contain at least one number.</li>
      </ul>
    </div>
    <div class="row pt-2" *ngIf="createFlag">
      <div class="col">
        <app-st-input-sensitive-text [idVal]="'password-text-id'"
                           [label]="'*Password'" [inputVal]="savedPassword" [requiredVal]="true"></app-st-input-sensitive-text>
      </div>
      <div class="col">
        <app-st-input-sensitive-text [idVal]="'password-repeat-text-id'"
                                     [label]="'*Repeat Password'" [inputVal]="savedPassword" [requiredVal]="true"></app-st-input-sensitive-text>
      </div>
    </div>
    <div>
      <div class="row pt-2" *ngIf="!createFlag">
        <div class="col">
          <app-st-input-text  [idVal]="'username-text-id'"
                              [label]="'*Username'" [inputVal]="savedUsername"
                              [disabled]="true"
          ></app-st-input-text>
        </div>
      </div>
      <br><br>

      <div *ngIf="createFlag && this.selectedSubscriptionPlan">
        <app-st-header-title [inputVal]="'Selected Subscription Plan'"></app-st-header-title>
        <div class="container st-pricing-form webtext-black"  >
          <div>
            <app-st-input-text [idVal]="'promo-code-text-id'" [label]="'Promo Code'"></app-st-input-text>
          </div>
          <br><br>
          <div class="row" *ngIf="this.selectedSubscriptionPlan['userCount'] == 1">
            <div class="col-sm-2" >
            </div>
            <div class="col-sm-8" >
              <div class="card">
                <div class="card-body">
                  <h5 class="card-title webtext-black">{{this.selectedSubscriptionPlan['subscriptionPlanDisplayName']}}</h5>
                  <h5 class="card-title webtext-black">{{this.selectedSubscriptionPlan['displayLength']}}</h5>
                  <br>
                  <p class="card-text webtext-black" *ngIf="(this.selectedSubscriptionPlan['totalPrice'] < this.selectedSubscriptionPlan['originalTotalPrice'])">
                    Full Price: <del>$ {{this.selectedSubscriptionPlan['originalTotalPriceFormatted']}}</del>
                  </p>
                  <p class="card-text webtext-black" *ngIf="(this.selectedSubscriptionPlan['totalPrice'] >= this.selectedSubscriptionPlan['originalTotalPrice'])">
                    &nbsp;
                  </p>
                  <!--<p class="card-text webtext-black">Your Price: $ {{this.selectedSubscriptionPlan['totalPriceFormatted']}}</p>-->
                  <p class="card-text webtext-black">${{this.selectedSubscriptionPlan['pricePerMonth']}} per month.</p>
                  <p class="card-text webtext-black"><i>${{this.selectedSubscriptionPlan['totalPriceFormatted']}} billed annually.</i></p>
                  <a id="change-subplan-alink-id" class="subplan-link" (click)="this.saveInfoAndRedirectToPricingPage()">Change Subscription Plan</a><br>
                </div>
              </div>
            </div>
            <div class="col-sm-2" >
            </div>
          </div>
          <div class="row" *ngIf="this.selectedSubscriptionPlan['userCount'] > 1">
            <div class="col-sm-5" >
              <div class="card">
                <div class="card-body">
                  <h5 class="card-title webtext-black">{{this.selectedSubscriptionPlan['subscriptionPlanDisplayName']}}</h5>
                  <h5 class="card-title webtext-black">{{this.selectedSubscriptionPlan['displayLength']}}</h5>
                  <br>
                  <p class="card-text webtext-black" *ngIf="(this.selectedSubscriptionPlan['totalPrice'] < this.selectedSubscriptionPlan['originalTotalPrice'])">
                    Full Price: <del>$ {{this.selectedSubscriptionPlan['originalTotalPriceFormatted']}}</del>
                  </p>
                  <p class="card-text webtext-black" *ngIf="(this.selectedSubscriptionPlan['totalPrice'] >= this.selectedSubscriptionPlan['originalTotalPrice'])">
                    &nbsp;
                  </p>
                  <!--<p class="card-text webtext-black">Your Price: $ {{this.selectedSubscriptionPlan['totalPriceFormatted']}}</p>-->
                  <p class="card-text webtext-black">${{this.selectedSubscriptionPlan['pricePerMonth']}} per month.</p>
                  <p class="card-text webtext-black"><i>${{this.selectedSubscriptionPlan['totalPriceFormatted']}} billed annually.</i></p>
                  <a id="change-subplan-2-id" class="subplan-link" (click)="this.saveInfoAndRedirectToPricingPage()">Change Subscription Plan</a>
                  <br>
                  <br>
                  <br>
                  <br>
                  <br>
                  <br>
                </div>
              </div>
            </div>
            <div class="col-sm-7" >
              <div class="card">
                <div class="card-body">
                  <h5 class="card-title webtext-black">Additional Emails</h5>
                  <p class="webtext-black"><b>Additional Users (All users will start with the same password):</b></p>
                  <div *ngIf="this.selectedSubscriptionPlan['userCount'] == 3">
                    <div class="row pt-2" >
                      <div class="col">
                        <app-st-input-text [idVal]="'visionary-additional-emails-1-text-id'"
                                           [label]="'Additional User 1 Email:'" [requiredVal]="false" [placeHolderVal]="'Additional User 1 Email:'"></app-st-input-text>
                      </div>
                    </div>
                    <div class="row pt-2" >
                      <div class="col">
                        <app-st-input-text [idVal]="'visionary-additional-emails-2-text-id'"
                                           [label]="'Additional User 2 Email:'" [requiredVal]="false" [placeHolderVal]="'Additional User 2 Email:'"></app-st-input-text>
                      </div>
                    </div>
                    <br>
                    <br>
                    <br>
                    <br>
                    <br>
                    <br>
                  </div>
                  <div *ngIf="this.selectedSubscriptionPlan['userCount'] == 5">
                    <div class="row pt-2" >
                      <div class="col">
                        <app-st-input-text [idVal]="'trailblazer-additional-emails-1-text-id'"
                                           [label]="'Additional User 1 Email:'" [requiredVal]="false" [placeHolderVal]="'Additional User 1 Email:'"></app-st-input-text>
                      </div>
                    </div>
                    <div class="row pt-2">
                      <div class="col">
                        <app-st-input-text [idVal]="'trailblazer-additional-emails-2-text-id'"
                                           [label]="'Additional User 2 Email:'" [requiredVal]="false" [placeHolderVal]="'Additional User 2 Email:'"></app-st-input-text>
                      </div>
                    </div>
                    <div class="row pt-2">
                      <div class="col">
                        <app-st-input-text [idVal]="'trailblazer-additional-emails-3-text-id'"
                                           [label]="'Additional User 3 Email:'" [requiredVal]="false" [placeHolderVal]="'Additional User 3 Email:'"></app-st-input-text>
                      </div>
                    </div>
                    <div class="row pt-2">
                      <div class="col">
                        <app-st-input-text [idVal]="'trailblazer-additional-emails-4-text-id'"
                                           [label]="'Additional User 4 Email:'" [requiredVal]="false" [placeHolderVal]="'Additional User 4 Email:'"></app-st-input-text>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!--
      <div *ngIf="createFlag">
        <app-st-header-title [inputVal]="'Select Subscription Plan'"></app-st-header-title>
        <table class="table table-striped webtext-black">
          <thead>
          <tr>
            <th scope="col"><b>Grassroots</b></th>
            <th scope="col"><b>Visionary</b></th>
            <th scope="col"><b>Trailblazer</b></th>
          </tr>
          </thead>
          <tbody>
          <tr>
            <td>
              <div class="form-check">
                <input class="form-check-input radio-button-properties" type="radio" value="true" id="grassroots-radio-button-id"
                       (click)="toggleGrassrootsRadioButton()" [checked]="grassrootsRadioButton">
                <app-st-span [inputVal]="'Total: 1 User'"></app-st-span>
              </div>
            </td>
            <td>
              <div class="form-check">
                <input class="form-check-input radio-button-properties" type="radio" value="true" id="visionary-radio-button-id"
                       (click)="toggleVisionaryRadioButton()" [checked]="visionaryRadioButton">
                <app-st-span [inputVal]="'Total: 3 Users'"></app-st-span>
              </div>
            </td>
            <td>
              <div class="form-check">
                <input class="form-check-input radio-button-properties" type="radio" value="true" id="trailblazer-radio-button-id"
                       (click)="toggleTrailblazerRadioButton()" [checked]="trailblazerRadioButton">
                <app-st-span [inputVal]="'Total: 5 Users'"></app-st-span>
              </div>
            </td>
          </tr>
          </tbody>
        </table>

          <br><br>
          <app-st-header-title [inputVal]="'Select Subscription Plan Length (Months)'"></app-st-header-title>
          <div class="container st-pricing-form webtext-black" *ngIf="(this.grassrootsRadioButton || this.visionaryRadioButton || this.trailblazerRadioButton); else NoSubscriptionPlanMonthsSelected" >
            <div>
              <app-st-input-text [idVal]="'promo-code-text-id'" [label]="'Promo Code'"></app-st-input-text>
            </div>
            <br><br>
            <div class="row">
              <div *ngFor="let subscriptionPricePlan of currentSubscriptionPlans;  let i1 = index" class="col-sm-4" >
                <div class="card">
                  <div class="card-body">
                    <h5 class="card-title webtext-black">{{subscriptionPricePlan.subscriptionPlanDisplayName}}</h5>
                    <h5 class="card-title webtext-black">{{subscriptionPricePlan.displayLength}}</h5>
                    <br>
                    <p class="card-text webtext-black" *ngIf="(subscriptionPricePlan['totalPrice'] < subscriptionPricePlan['originalTotalPrice'])">
                      Full Price: <del>$ {{subscriptionPricePlan['originalTotalPriceFormatted']}}</del>
                    </p>
                    <p class="card-text webtext-black" *ngIf="(subscriptionPricePlan['totalPrice'] >= subscriptionPricePlan['originalTotalPrice'])">
                      &nbsp;
                    </p>
                    <p class="card-text webtext-black">Your Price: $ {{subscriptionPricePlan['totalPriceFormatted']}}</p>
                    <div class="form-check">
                      <input class="form-check-input radio-button-properties" type="radio" value="true" id="subscription-plan-length-{{i1}}-radio-button-id"
                             (click)="toggleCurrentSubscriptionPlanRadioButtonFinal(i1)" [checked]="subscriptionPricePlan.checked">
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <ng-template #NoSubscriptionPlanMonthsSelected >
            <div class="d-flex justify-content-center">
              <br>
              <br>
              <span class="webtext-black"><b>No Subscription Plan Selected</b></span>
            </div>
          </ng-template>
      </div>-->

      <!--
      <br><br>
      <div *ngIf="createFlag && visionaryRadioButton && this.visionaryRadioButtonFinal">
        <p class="webtext-black"><b>Additional Users (All users will start with the same password):</b></p>
        <div class="row pt-2" >
          <div class="col">
            <app-st-input-text [idVal]="'visionary-additional-emails-1-text-id'"
                               [label]="'Additional User 1 Email:'" [requiredVal]="false" [placeHolderVal]="'Additional User 1 Email:'"></app-st-input-text>
          </div>
        </div>
        <div class="row pt-2" >
          <div class="col">
            <app-st-input-text [idVal]="'visionary-additional-emails-2-text-id'"
                               [label]="'Additional User 2 Email:'" [requiredVal]="false" [placeHolderVal]="'Additional User 2 Email:'"></app-st-input-text>
          </div>
        </div>
      </div>
       <div *ngIf="createFlag && trailblazerRadioButton && this.trailblazerRadioButtonFinal">
         <p class="webtext-black"><b>Additional Users (All users will start with the same password):</b></p>
          <div class="row pt-2" >
            <div class="col">
              <app-st-input-text [idVal]="'trailblazer-additional-emails-1-text-id'"
                                 [label]="'Additional User 1 Email:'" [requiredVal]="false" [placeHolderVal]="'Additional User 1 Email:'"></app-st-input-text>
            </div>
          </div>
          <div class="row pt-2">
            <div class="col">
              <app-st-input-text [idVal]="'trailblazer-additional-emails-2-text-id'"
                                 [label]="'Additional User 2 Email:'" [requiredVal]="false" [placeHolderVal]="'Additional User 2 Email:'"></app-st-input-text>
            </div>
          </div>
         <div class="row pt-2">
           <div class="col">
             <app-st-input-text [idVal]="'trailblazer-additional-emails-3-text-id'"
                                [label]="'Additional User 3 Email:'" [requiredVal]="false" [placeHolderVal]="'Additional User 3 Email:'"></app-st-input-text>
           </div>
         </div>
         <div class="row pt-2">
           <div class="col">
             <app-st-input-text [idVal]="'trailblazer-additional-emails-4-text-id'"
                                [label]="'Additional User 4 Email:'" [requiredVal]="false" [placeHolderVal]="'Additional User 4 Email:'"></app-st-input-text>
           </div>
         </div>
       </div>
    </div>-->
    <br>
    <div class="row pt-3" *ngIf="createFlag">
      <div class="col">
        <a id="terms-and-conditions-alink-id" class="terms-conditions-link" href="https://www.scalanthropy.com/terms-conditions" target="_blank">View Terms and Conditions</a>
        <br>
        <div class="form-check">
          <input class="form-check-input radio-button-properties" type="radio" value="true" id="legal-agreement-radio-button-id"
                 (click)="toggleLegalAgreement()" [checked]="termsAndConditionsRadioButton">
          <app-st-span [inputVal]="'I Agree'"></app-st-span>
        </div>
      </div>
    </div>
    <br>
    <app-st-button-back-to-top></app-st-button-back-to-top>
    <br>
    <br>
    <div *ngIf="showSuccessMessages" class="container st-messages-form text-success" #goUp>
      <app-st-span><b>Please validate the following: </b></app-st-span>
      <div *ngFor="let successMsg of successMessages" class="alert alert-success" role="alert">
        <b>{{successMsg.field}}:</b> {{successMsg.detail}}
      </div>
      <br>
    </div>
    <div *ngIf="showMessages" class="container st-messages-form text-danger" #goUp>
      <app-st-span><b>Please validate the following: </b></app-st-span>
      <div *ngFor="let errorMsg of messages" class="alert alert-danger" role="alert">
        <b>{{errorMsg.field}}:</b> {{errorMsg.detail}}
      </div>
      <br>
    </div>
    <br>
    <div class="col2 d-grid gap-2 d-md-flex justify-content-md-end align-items-end">
      <app-st-button-cancel [idVal]="'bottom-cancel-button-id'" [label]="'Cancel'" [primary]="false"
                            (click)="this.onCancel()"></app-st-button-cancel>
      <app-st-button [idVal]="'bottom-save-button-id'" [label]="'Submit'" [primary]="true"
                     (click)="this.onSave()"></app-st-button>
    </div>
    <br>
    <br>
    <br>
  </div>
</div>


<!--
<div class="col-sm-3" >
              </div>
              <div class="col-sm-6" >
                <div class="card">
                  <div class="card-body">
                    <h5 class="card-title webtext-black">{{this.currentSubscriptionPlans[0].subscriptionPlanDisplayName}}</h5>
                    <h5 class="card-title webtext-black">{{this.currentSubscriptionPlans[0].displayLength}}</h5>
                    <br>
                    <p class="card-text webtext-black" *ngIf="(this.currentSubscriptionPlans[0]['totalPrice'] < this.currentSubscriptionPlans[0]['originalTotalPrice'])">
                      Full Price: <del>$ {{this.currentSubscriptionPlans[0]['originalTotalPriceFormatted']}}</del>
                    </p>
                    <p class="card-text webtext-black" *ngIf="(this.currentSubscriptionPlans[0]['totalPrice'] >= this.currentSubscriptionPlans[0]['originalTotalPrice'])">
                      &nbsp;
                    </p>
                    <p class="card-text webtext-black">$ {{this.currentSubscriptionPlans[0]['totalPrice']/12}} per month.</p>
                    <p class="card-text webtext-black"><i>$ {{this.currentSubscriptionPlans[0]['totalPriceFormatted']}} billed annually.</i></p>
                    <div class="form-check">
                      <input class="form-check-input radio-button-properties" type="radio" value="true" id="subscription-plan-length-0-radio-button-id"
                             (click)="toggleCurrentSubscriptionPlanRadioButtonFinal(0)" [checked]="this.currentSubscriptionPlans[0].checked">
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-sm-3" >
              </div>
-->
